import React from 'react';
import { required, SelectInput, TextInput } from 'react-admin';
import { Grid } from '@material-ui/core';
import ISConfig from '../config';
import SystemElement from './SystemElement';
import CustomLabelInput from '../components/CustomLabelInput';

const SystemElements = ({ type }) => {
    console.log(ISConfig.system_types)

    var elementSystemsAux = []
    for (const key in ISConfig.system_types) {
        if (key == type.toLowerCase()) {
            ISConfig.system_types[key].elements.forEach(element => {
                elementSystemsAux.push( <SystemElement id={element.id} name={(ISConfig.system_elements[element.id] != undefined || ISConfig.system_elements[element.id] != null)? ISConfig.system_elements[element.id].label : 'element not defined' } /> )
            });
        }
    }

    return ( <> {elementSystemsAux} </> )
}

class SystemAddForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: '',
        };
    }

    handleAvailability(event) { this.setState({ type: event.target.value }); }

    render() {
        var SystemTypeSelectChoicesRequired = [];
        for (const key in ISConfig.system_types) { SystemTypeSelectChoicesRequired.push({ id: ISConfig.system_types[key].label, name: ISConfig.system_types[key].label }) }
        return (
            <>
                <Grid container direction="row" spacing={2} className="px-2">
                    <Grid item xs={12} sm={6} className="py-0">
                        <TextInput
                            source="name"
                            label={<CustomLabelInput label="Name" />}
                            validate={required()}
                            style={{ width: "100%" }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} className="py-0">
                        <SelectInput
                            onChange={this.handleAvailability.bind(this)}
                            label={<CustomLabelInput label="Type" />}
                            source="type"
                            validate={required()}
                            choices={SystemTypeSelectChoicesRequired}
                            style={{ width: "100%" }}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" spacing={2} style={{ padding: '5px' }} className="py-0">
                    <SystemElements type={this.state.type} />
                </Grid>
            </>
        )
    }
}

export default SystemAddForm;